import type { AlertDtoAction } from '@/api/WhisApi/generated';

type NotificationTranslation = (
  key: string,
  options?: Record<string, string>,
) => string;

interface AlertWordingKeys {
  titleKey: string;
  descriptionKey: string;
}

const DEFAULT_ALERT_WORDING_KEYS: AlertWordingKeys = {
  titleKey: 'alerts.updateOnReport',
  descriptionKey: 'alerts.reportUpdated',
};

const ALERT_WORDING_KEYS: Record<AlertDtoAction, AlertWordingKeys> = {
  updated: {
    titleKey: 'alerts.updateOnReport',
    descriptionKey: 'alerts.reportUpdated',
  },
  saved: {
    titleKey: 'alerts.savedOnReport',
    descriptionKey: 'alerts.reportSaved',
  },
  RRARequested: {
    titleKey: 'alerts.rraRequestedOnReport',
    descriptionKey: 'alerts.reportRraRequested',
  },
  RRACompleted: {
    titleKey: 'alerts.rraCompletedOnReport',
    descriptionKey: 'alerts.reportRraCompleted',
  },
  draft: {
    titleKey: 'alerts.draftOnReport',
    descriptionKey: 'alerts.reportDraft',
  },
};

export const getAlertWording = (
  t: NotificationTranslation,
  action: AlertDtoAction,
  reportCode: string,
): { title: string; description: string } => {
  const keys = ALERT_WORDING_KEYS[action] ?? DEFAULT_ALERT_WORDING_KEYS;

  return {
    title: t(keys.titleKey),
    description: t(keys.descriptionKey, { reportCode }),
  };
};
